import { BaseSidebarObject } from '@y42/gojs';
import { IZOrderableNode } from '../../common/models/node.interfaces';

export class GroupNode extends BaseSidebarObject implements IZOrderableNode {
  constructor(
    public key = '',
    public category = '',
    public location = '0 0',
    public size = '0 0',
    public isGroup = true,
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
